import React, { useState } from "react";
import lockupHorizontal from "./assets/brand/lockup-horizontal.svg";

// Shown to a cashier on a mobile-width viewport when the store's
// mobile_pos_enabled setting is off and they don't have an approved
// mobile_access_requests row (see App.js's gating check). Managers always
// bypass this screen. Not a real mobile dashboard — just a blocking
// message with a path to My Sales and a way to ask for individual access.
export default function MobilePosBlocked({
  storeName,
  mySalesEnabled,
  onOpenMySales,
  accessRequest,
  onRequestAccess,
}) {
  const [submitting, setSubmitting] = useState(false);

  async function handleRequestAccess() {
    setSubmitting(true);
    await onRequestAccess();
    setSubmitting(false);
  }

  const buttonStyle = {
    padding: "10px 20px",
    borderRadius: "var(--radius)",
    border: "1px solid var(--border)",
    background: "var(--elevated)",
    color: "var(--text2)",
    fontSize: "13px",
    fontFamily: "var(--font)",
    cursor: "pointer",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: "14px",
        padding: "32px",
        background: "var(--bg)",
        color: "var(--text)",
      }}
    >
      <img
        src={lockupHorizontal}
        alt="SuqPOS"
        style={{ height: "34px", width: "auto", marginBottom: "6px" }}
      />
      <p style={{ fontSize: "15px", fontWeight: 700, margin: 0 }}>
        {storeName}
      </p>
      <p
        style={{
          fontSize: "14px",
          color: "var(--text2)",
          maxWidth: "320px",
          lineHeight: 1.5,
          margin: 0,
        }}
      >
        Full POS is available on desktop. Ask your manager to enable mobile
        access in Settings if you need it here.
      </p>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px",
          marginTop: "10px",
        }}
      >
        {mySalesEnabled && (
          <button style={buttonStyle} onClick={onOpenMySales}>
            🧾 View My Sales
          </button>
        )}

        {!accessRequest && (
          <button
            style={buttonStyle}
            onClick={handleRequestAccess}
            disabled={submitting}
          >
            {submitting ? "Requesting..." : "📩 Request Access"}
          </button>
        )}

        {accessRequest?.status === "pending" && (
          <p style={{ fontSize: "13px", color: "var(--text3)", margin: 0 }}>
            ⏳ Request pending — waiting for your manager
          </p>
        )}

        {accessRequest?.status === "denied" && (
          <p style={{ fontSize: "13px", color: "var(--red)", margin: 0 }}>
            ❌ Request denied — contact your manager
          </p>
        )}
      </div>
    </div>
  );
}
